import { SET_ROUTE } from "./actionTypes";
import initialState  from './initialState'

const routeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ROUTE:
            return {
                ...state,
                route: action.payload
            };
        default:
            return state;
    }
};

export default routeReducer;
